<template>
  <div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section prev-test-tb">
        <v-data-table
          :headers="computedHeaders"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onSortChange="onSortChange"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
            />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td
                  class="rescheduletest"
                  @click="gotoPastTest(item)"
                >
                  {{ item.test_name }}
                </td>
                <td class="text-center">{{ item.duration }}</td>
                <!-- <td class="text-center">{{ item.test_type }}</td> -->
                <td class="text-center">{{ item.target_name }}</td>
                <td class="text-center">{{ getFormatedDate(item.date_answered) }}</td>
                <td class="text-center">{{ item.your_marks }}</td>
                <td class="text-center" v-if="testType == constants.TEST_TYPE.MYT">{{ item.subjects }}</td>
                <td class="text-center" v-if="testType != constants.TEST_TYPE.MYT">{{ item.all_india_rank }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div class="btm-test-prev-test">
          Click on a test name to revisit that test
        </div>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination 
          :currentPage="currentPage" 
          :totalPage="totalPages" 
          :onPageChange="onPageChange" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "OnlinePastTestList",
  props: {
    testType: {
      type: Number,
      required: true,
      validator: (value) => [constants.TEST_TYPE.PREVIOUS_YEAR, constants.TEST_TYPE.ALL_INDIA_TEST, constants.TEST_TYPE.MYT].includes(value),
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
    }),
    computedHeaders() {
      const baseHeaders = [
        { text: "Test Name", value: "alt_test_name" },
        {
          text: "Duration (Min)",
          value: "duration",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Target Exam",
          value: "target_name",
          class: "text-center",
          type: "multidropdown",
          options: this.targets || [],
          allText: "All Target Exams",
        },
        {
          text: "Date Answered",
          value: "date_answered",
          class: "text-center",
        },
        {
          text: "Your Marks",
          value: "your_marks",
          class: "text-center",
          hideSort: true,
        },
      ];
      if (this.testType == constants.TEST_TYPE.MYT) {
        baseHeaders.push({
          text: "Subjects",
          value: "subjects",
          class: "text-center",
          hideSort: true,
        });
      }
      if (this.testType != constants.TEST_TYPE.MYT) {
        baseHeaders.push({
          text: this.testType == 2 ? "All India Rank" : "Projected A.I.R",
          value: "all_india_rank",
          class: "text-center",
          hideSort: true,
        });
      }
      return baseHeaders;
    },
  },
  data() {
    return {
      constants,
      targets: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "test_name",
        order: "ASC",
      },
      selectedExamTypes: [],
      selectedTestTypes: [],
      examTypes: [],
    };
  },
  mounted() {
    this.defaultData();
  },
  methods: {
    ...mapActions({
      getOnlinePastTestList: "testStore/getOnlinePastTestList",
    }),

    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      
      if (crd && crd.tabDetails && crd.tabDetails[this.testType]) {
        this.currentPage = crd.tabDetails[this.testType].page;
        this.orderBy = crd.tabDetails[this.testType].orderBy;
        this.selectedExamTypes = crd.tabDetails[this.testType].examTypes || [];
        this.selectedTestTypes = crd.tabDetails[this.testType].testTypes || [];
      }
      
      this.requestGetTestList();
      this.reqGetTestTargets();
    },

    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    gotoPastTest(item) {
      let test_institute_id = item.test_institute_id;
      this.$router.push({
        name: "past-test-details",
        params: { 
          test_id: item.id,
          test_institute_id,
        },
      });
    },

    onPageChange(e) {
      this.currentPage = e;
      this.updateRouteDetails();
      this.requestGetTestList();
    },

    onSortChange() {
      this.updateRouteDetails();
      this.requestGetTestList();
    },

    onHeaderAction(e) {
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "test_type"
      ) {
        this.selectedTestTypes = e.data.selectedItems;
      } else if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "target_name"
      ) {
        this.selectedExamTypes = e.data.selectedItems;
      }
      this.onPageChange(1);
    },

    updateRouteDetails() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      
      if (crd && crd.tabDetails && crd.tabDetails[this.testType]) {
        crd.tabDetails[this.testType].page = this.currentPage;
        crd.tabDetails[this.testType].orderBy = this.orderBy;
        crd.tabDetails[this.testType].examTypes = this.selectedExamTypes;
        crd.tabDetails[this.testType].testTypes = this.selectedTestTypes;
        this.setRouteDetails(crd);
      }
    },

    requestGetTestList() {
      if(this.testType) {
        let reqData = {
          type: this.testType ? Number(this.testType) : null,
          test_types: this.selectedTestTypes,
          target_ids: this.selectedExamTypes,
          orderBy: this.orderBy,
          test_name: null,
          pagination: { 
            page: this.currentPage, 
            pageSize: this.pageSize 
          },
        };

        this.$root.showLoader = true;
        this.getOnlinePastTestList(reqData)
          .then((response) => {
            if (
              response.list.length == 0 &&
              this.currentPage != 1 &&
              !this.$route.query.resetPage
            ) {
              this.onPageChange(1);
              return;
            }
            this.$root.showLoader = false;
            this.items = response.list;
            this.totalPages = response.pagination.pageCount;
          })
          .catch((err) => {
            this.$root.showLoader = false;
            this.items = [];
          });
      }
    },

    reqGetTestTargets() {
      // Determine target exam group based on user's target exam
      const targetExamId = this.user && this.user.target_exam && this.user.target_exam.exam_id 
        ? this.user.target_exam.exam_id 
        : null;
      
      let targetTabs = [];
      
      // Check if user's target exam belongs to Medical or Engineering group
      if (targetExamId === constants.TARGET_EXAM_GROUPS.MEDICAL) {
        // Medical group - get tabs from TARGET_EXAM_TABS
        targetTabs = constants.TARGET_EXAM_TABS[571];
      } else if (targetExamId === constants.TARGET_EXAM_GROUPS.ENGINEERING) {
        // Engineering group - get tabs from TARGET_EXAM_TABS
        targetTabs = constants.TARGET_EXAM_TABS[572];
      } else {
        // If no target group, combine all exams from both groups
        targetTabs = [
          ...constants.TARGET_EXAM_TABS[571],
          ...constants.TARGET_EXAM_TABS[572]
        ].filter((tab, index, self) => 
          index === self.findIndex(t => t.value === tab.value)
        );
      }
      targetTabs = targetTabs.filter(t => t.value !== 9 && t.value !== 11 && t.value !== 12 && t.value !== 13);
      
      // Map target tabs directly to targets
      this.targets = targetTabs.map((tab) => {
        return {
          text: tab.text,
          value: tab.value,
          checked: false,
        };
      });
      
      this.$forceUpdate();
    },
  },
  watch: {
    testType: {
      immediate: false,
      handler(newVal, oldVal) {
        if (oldVal) {
          this.defaultData();
        }
      },
    },
  },
};
</script>

